import PropTypes from 'prop-types';
import defaultLogo from '../../assets/images/logos/ty-default.png';
import halloweenLogo from '../../assets/images/logos/ty-hallowen.png';
import fallLogo from '../../assets/images/logos/ty-podzim.png';
import adventLogo from '../../assets/images/logos/ty-advent.png';
import christmasLogo from '../../assets/images/logos/ty-vanoce.png';
import newYearLogo from '../../assets/images/logos/ty-silvestr.png';
import classNames from 'classnames';
import moment from 'moment';

const format = 'DD.MM.';

const halloween = ['24.10.', '31.10.'];
const fall = ['01.11.', '29.11.'];
const advent = ['30.11.', '23.12.'];
const christmas = ['24.12.', '30.12.'];
const newYears = ['31.12.', '04.01.'];

const Tymbe = ({ textcolor = '#28367B', className }) => {
  const now = moment();
  const isHalloween = now.isBetween(moment(halloween[0], format).startOf('day'), moment(halloween[1], format).endOf('day'));
  const isFall = now.isBetween(moment(fall[0], format).startOf('day'), moment(fall[1], format).endOf('day'));
  const isAdvent = now.isBetween(moment(advent[0], format).startOf('day'), moment(advent[1], format).endOf('day'));
  const isChristmas = now.isBetween(moment(christmas[0], format).startOf('day'), moment(christmas[1], format).endOf('day'));
  const isNewYears = now.isBetween(moment(newYears[0], format).startOf('day').subtract(now.month() === 0 ? 1 : 0, 'year'), moment(newYears[1], format).endOf('day').add(now.month() > 0 ? 1 : 0, 'year'));

  let logo = defaultLogo;
  let size = 'w-14 h-14';
  if (isHalloween) {
    logo = halloweenLogo;
  } else if (isFall) {
    logo = fallLogo;
  } else if (isAdvent) {
    logo = adventLogo;
  } else if (isChristmas) {
    logo = christmasLogo;
  } else if (isNewYears) {
    logo = newYearLogo;
  } else {
    // default logo size
    size = 'w-12 h-12';
  }

  return (
    <div className={classNames(className)}>
      <img src={logo} alt="logo" className={size} />
    </div>
  );
};

Tymbe.propTypes = {
  textcolor: PropTypes.string,
};

export default Tymbe;
